
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/[[...slug]]",
      function () {
        return require("private-next-pages/about-us/[[...slug]].page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/[[...slug]]"])
      });
    }
  